import { render, staticRenderFns } from "./SysWord.vue?vue&type=template&id=7976409c&scoped=true&"
import script from "./SysWord.vue?vue&type=script&lang=js&"
export * from "./SysWord.vue?vue&type=script&lang=js&"
import style0 from "./SysWord.vue?vue&type=style&index=0&id=7976409c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7976409c",
  null
  
)

export default component.exports